import { StreamParser } from '../ai-stream-parser/StreamParser';
import { PATH_PREFIX } from '@/config/constant';
import { getTraceIdHeaders, AI_MODULE_MAP } from '@/modules/ai/helper';
import { STAINLESS_NULL_HEADERS } from '@/utils/openai-sdk';
import OpenAI from 'openai';
import { createWujiAI } from '@tencent/wuji-utils';
let openai = null;
function getOpenAiInstance() {
    let projectId = '';
    let env = 'dev';
    if (window?.RUNTIME_CONFIGS) {
        ({ projectId, env } = window.RUNTIME_CONFIGS);
    }
    else {
        const query = new URLSearchParams(window.location.search);
        projectId = query.get('projectId') || query.get('projectid') || '';
    }
    if (!projectId || !env)
        return;
    return new OpenAI({
        apiKey: '',
        baseURL: `${window.location.origin}${PATH_PREFIX}/api/xy/runtime/llm`,
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            ...STAINLESS_NULL_HEADERS,
            'xy-project-id': projectId,
            'xy-env': env,
            ...getTraceIdHeaders(AI_MODULE_MAP.RUNTIME_AI_SDK),
        },
    });
}
function initByImport() {
    openai = getOpenAiInstance();
}
class BrowserOpenAIClientProvider {
    getClient() {
        if (!openai)
            initByImport();
        return openai;
    }
}
const browserProvider = new BrowserOpenAIClientProvider();
export const wujiAI = createWujiAI(() => browserProvider);
export function getLLMInstance() {
    return new Proxy({}, {
        get(target, prop) {
            if (prop === 'init') {
                return () => initByImport();
            }
            if (prop === 'StreamParser') {
                return StreamParser;
            }
            return wujiAI[prop];
        },
    });
}
